import { render, staticRenderFns } from "./AdminManagingRbuList.vue?vue&type=template&id=93bd5ee8"
import script from "./AdminManagingRbuList.vue?vue&type=script&lang=js"
export * from "./AdminManagingRbuList.vue?vue&type=script&lang=js"
import style0 from "./AdminManagingRbuList.vue?vue&type=style&index=0&id=93bd5ee8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports